import { Component, Vue, Watch } from 'vue-property-decorator';
import { request } from '@/tools/request';

@Component<Permissions>({
  components: {
    //
  },
})
export default class Permissions extends Vue {
  protected onlinePermission: boolean = false;
  protected libraryPermission: boolean = false;
  protected allowConfirm: boolean = false;
  protected confirmed: boolean = false;
  protected currentStudent: any = {};
  protected firstChangeDone: boolean = false;

  public mounted() {
    document.addEventListener('click', (e: any) => {
      if (e.target.classList.contains('overlay')) this.confirmed = false;
    });
    this.getClasses();
  }

  protected getClasses() {
    request('get', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/classes').then(
      (response: any) => {
        response.data.forEach((element: any, index: any) => {
          if (element.id === '2019035') {
            this.currentStudent = element;
            if (element.data.status === 'enrolled') {
              this.libraryPermission = true;
            } else {
              this.libraryPermission = false;
            }
          }
        });
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected confirmStudent() {
    let enrolledStatus = 'enrolled';
    this.confirmed = true;
    this.allowConfirm = false;
    if (!this.libraryPermission) {
      enrolledStatus = 'not enrolled';
    }
    this.updateStudent(enrolledStatus);
  }

  protected updateStudent(enrolledStatus: string) {
    const payload: any = {
      id: '2019035',
      statusUpdate: enrolledStatus,  
    };

    request('post', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/updateStatus', payload).then(
      (response: any) => {
        //
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }
  
  @Watch('onlinePermission', {deep: true})
    protected onlinePermissionWatch(to: any) {
      this.allowConfirm = true;
  }

  @Watch('libraryPermission', {deep: true})
    protected libraryPermissionWatch(to: any) {
      if (this.firstChangeDone) {
        this.allowConfirm = true;
      }
      this.firstChangeDone = true;
  }
}
